import React from 'react';

// custom hook to get prevProps / prevState
// https://blog.logrocket.com/accessing-previous-props-state-react-hooks/
export function usePrevious(value) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value; // assign the value of ref to the argument
    }, [value]); // this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
}

export function useReadStateSuccess(value) {
    const prevValue = usePrevious(value);
    return value === 'success' && prevValue === 'request';
}

export function useReadStateError(value) {
    const prevValue = usePrevious(value);
    return value === 'error' && prevValue === 'request';
}
